import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "description", "feedback", "gutter", "hint", "inline", "intent", "labelCols", "labelFor", "labelIcon", "labelSize", "labelText"];
import { FormGroup } from '@flowio/react-form-group';
import React from 'react';
import Select from './Select';

var SelectField = function SelectField(_ref) {
  var className = _ref.className,
      description = _ref.description,
      feedback = _ref.feedback,
      gutter = _ref.gutter,
      hint = _ref.hint,
      inline = _ref.inline,
      intent = _ref.intent,
      labelCols = _ref.labelCols,
      labelFor = _ref.labelFor,
      labelIcon = _ref.labelIcon,
      labelSize = _ref.labelSize,
      labelText = _ref.labelText,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(FormGroup, {
    className: className,
    description: description,
    feedback: feedback,
    gutter: gutter,
    hint: hint,
    inline: inline,
    intent: intent,
    labelCols: labelCols,
    labelFor: labelFor,
    labelIcon: labelIcon,
    labelSize: labelSize,
    labelText: labelText
  }, /*#__PURE__*/React.createElement(Select, _extends({}, unhandledProps, {
    intent: intent
  })));
};

SelectField.displayName = 'SelectField';
export default SelectField;